$.extend($.validator.messages, {
  required: "不能为空",
  email: "请输入正确格式的邮箱",
  date: "请输入有效的日期",
  digits: "只能输入数字",
  maxlength: $.validator.format("最多可以输入 {0} 个字符"),
  minlength: $.validator.format("最少要输入 {0} 个字符"),
  rangelength: $.validator.format("请输入长度在 {0} 到 {1} 之间的字符串"),
  range: $.validator.format("请输入范围在 {0} 到 {1} 之间的数值"),
  max: $.validator.format("请输入不大于 {0} 的数值"),
  min: $.validator.format("请输入不小于 {0} 的数值")
});
// 判断XML
$.validator.addMethod('isXSS', function (value, element) {
  return this.optional(element) || !(/[<>\/]/.test(value))
}, '不能包含非法字符<>/')

// 判断为纯空格
$.validator.addMethod('isSpace', function (value, element) {
  var regu = /^[\s　]|[ ]$/gi;
  return this.optional(element) || !regu.test(value)
}, '首尾不能有空格')

//判断手机号码
$.validator.addMethod("isMobile", function(value, element) {  
  var length = value.length;  
  var mobile = /^(1[0-9][0-9]{9})$/;  
  return this.optional(element) || (length == 11 && mobile.test(value));  
}, '请正确填写您的手机号码');  


// WEBPACK FOOTER //
// ./src/js/libs/jquery.validate/jquery.validate-config.js